import { render, staticRenderFns } from "./AddOnLabelPurchaseReport.vue?vue&type=template&id=32461c77&scoped=true"
import script from "./AddOnLabelPurchaseReport.vue?vue&type=script&lang=ts"
export * from "./AddOnLabelPurchaseReport.vue?vue&type=script&lang=ts"
import style0 from "./AddOnLabelPurchaseReport.vue?vue&type=style&index=0&id=32461c77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32461c77",
  null
  
)

export default component.exports